import { UserRole } from "../types";

export const USERS_ROLES_MAP: Record<number, UserRole> = {
  10: "Owner",
  20: "Admin",
  30: "Manager",
  40: "Translator",
  50: "Translator Junior",
};
